<template>
  <div>
    <pre class="pageDescription text-justify" v-if="pageData.contents[0].description">{{ pageData.contents[0].description }}</pre>

    <div class="columns col-gapless">
      <div
        v-for="cardItem in pageData.childEntries.rows"
        :key="cardItem.id"
        class="column col-xs-12 col-md-6 col-4 card-border"
      >
        <h5 class="card-border_title">{{ cardItem.contents[0].title }}</h5>
        <div class="card-border_image">
          <img :src="cardItem.contents[0].thumb">
        </div>
        <div class="card-border_info">
          <div class="card-border__line fixed_width">
            <span>{{ getCaption("caption.card_type") }}:</span>
            {{ getJsonData(cardItem.contents[0].description).type }}
          </div>
          <div class="card-border__line fixed_width">
            <span>{{ getCaption("caption.card_price") }}:</span>
            {{ getJsonData(cardItem.contents[0].description).price }}
          </div>
          <div class="card-border__line">
            <span>{{ getCaption("caption.sales_branch") }}:</span>
            {{ getJsonData(cardItem.contents[0].description).branch }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pageData"],

  methods: {
    getJsonData(data) {
      data = data.replace(/\t/, "\\t");
      return JSON.parse(data);
    }
  }
};
</script>

<style lang="scss">
.card-border {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 0.3rem !important;

  .card-border_image {
    width: 75%;
    height: auto;
    display: block;
    margin: 1.1rem 0 0.4rem;

    img {
      width: 100%;
      height: auto;
    }
  }

  .card-border_info {
    padding-bottom: 0.8rem;
    .card-border__line {
      padding-bottom: 3px;

      span {
        padding-right: 10px;
      }
    }

    .card-border__line.fixed_width {
      span {
        width: 100px;
        display: inline-block;
      }
    }
    span {
      width: 100px;
      display: inline-block;
    }
  }
}
.card-border:nth-child(3n + 3) {
  border-right: 0 none;
}
.card-border:nth-last-child(-n + 3) {
  border-bottom: 0 none;
}
</style>
